/* eslint camelcase: "off" */
import React from 'react';
import axios from 'axios';
import { Alert, Card, CardBody, Col, Container, Row } from 'reactstrap';
import Swal from 'sweetalert2';
import { Formik, Field, ErrorMessage } from 'formik';
import Select from 'react-select';
import apiResponseHandler from '../../../utils/apiResponseHandler';
import { environment } from '../../../environment/environment';
import { sanitizeMobileNumber } from '../User/UserDetail';
import CustomIntlTelInput, { isMobileNumberValid } from '../../../components/Users/CustomIntlTelInput';

class EmployeeAddTemporary extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      employers: [],
      employer: null,
      mobile_number: {
        value: '',
        countryCode: '27',
        valid: false,
      },
      formError: false,
      employersFetchError: false,
      errors: {
        mobileNumberErrors: [],
      },
    };
  }

  componentDidMount() {
    this.getEmployers();
  }

  getEmployers = () => {
    const headers = {
      'Content-Type': 'application/json',
      'Access-Control-Allow-Origin': '*',
    };
    axios
      .get(`${environment.baseUrl}/employers/?`, { headers })
      .then((res) => {
        this.setState({
          employers: res.data.filter((employer) => employer.status === 'active'),
          employersFetchError: false,
        });
      })
      .catch((error) => {
        this.setState({ employers: [], employersFetchError: true });
        apiResponseHandler.handleApiError('Error loading employers', error);
      });
  };

  validateInputs = () => {
    const errors = {
      mobileNumberErrors: [],
    };

    if (!this.state.mobile_number.valid) {
      errors.mobileNumberErrors.push('User mobile number is incorrect.');
    }

    this.setState({
      errors,
      formError: Object.values(errors).flat().length > 0,
    });
    return Object.values(errors).flat().length === 0;
  };

  render() {
    const { employers, formError, employersFetchError, errors } = this.state;

    return (
      <>
        <div className="header bg-primary pb-6">
          <Container fluid>
            <div className="header-body">
              <Row className="align-items-center py-4">
                <Col lg="6">
                  <h6 className="h2 text-white d-inline-block mb-0">
                    Add Temporary Employee
                  </h6>
                </Col>
              </Row>
            </div>
          </Container>
        </div>
        <Container fluid className="mt--7">
          <Row className="pt-5 emp-edit-data">
            <Col lg="8" md="12" className="mx-auto">
              <Card className="shadow">
                <CardBody>
                  {employersFetchError && (
                    <Alert color="danger">
                      Could not load employers. Please refresh the page or try
                      again later.
                    </Alert>
                  )}
                  <Row>
                    <Col>
                      <Formik
                        initialValues={{
                          firstName: '',
                          lastName: '',
                          employer: this.state.employer,
                          mobile_number: this.state.mobile_number,
                          idNumber: '',
                        }}
                        validate={(values) => {
                          const errs = {};
                          if (!values.firstName) {
                            errs.firstName = 'Required';
                          }
                          if (!values.lastName) {
                            errs.lastName = 'Required';
                          }
                          if (!values.employer) {
                            errs.employer = 'Employer is required';
                          }
                          if (!values.mobile_number.valid) {
                            errs.mobile_number = 'Invalid mobile number';
                          } else {
                            this.setState({
                              mobile_number: values.mobile_number,
                            });
                          }
                          return errs;
                        }}
                        onSubmit={(values, { setSubmitting }) => {
                          if (!this.validateInputs()) {
                            setSubmitting(false);
                            return;
                          }

                          const payload = {
                            first_name: values.firstName,
                            last_name: values.lastName,
                            mobile_number: sanitizeMobileNumber(
                              values.mobile_number.value
                            ),
                            id_number: values.idNumber,
                            employer: this.state.employer,
                          };

                          axios
                            .post(
                              `${environment.baseUrl}/employees/temporary/`,
                              payload
                            )
                            .then((res) => {
                              Swal.fire({
                                title: 'Temporary employee created successfully',
                                icon: 'success',
                                toast: true,
                                position: 'top',
                                showConfirmButton: false,
                                timer: 3000,
                                timerProgressBar: true,
                              });
                              this.props.history.push(
                                `/admin/employees/${res.data.id}/`
                              );
                            })
                            .catch((error) => {
                              apiResponseHandler.handleApiError('Error', error);
                            })
                            .finally(() => {
                              setSubmitting(false);
                            });
                        }}>
                        {({ handleSubmit, setFieldValue, isSubmitting }) => (
                          <form onSubmit={handleSubmit}>
                            {formError && (
                              <Alert color="danger">
                                {Object.values(errors)
                                  .flat()
                                  .map((error) => (
                                    <li key={error}>{error}</li>
                                  ))}
                              </Alert>
                            )}
                            <Row>
                              <Col>
                                <h4>Personal</h4>
                              </Col>
                            </Row>
                            <Row>
                              <Col md={6} className="mb-3">
                                <Field
                                  name="firstName"
                                  className="form-control"
                                  placeholder="First name"
                                />
                                <ErrorMessage
                                  name="firstName"
                                  className="text-danger"
                                  component="small"
                                />
                              </Col>
                              <Col md={6} className="mb-3">
                                <Field
                                  name="lastName"
                                  className="form-control"
                                  placeholder="Last name"
                                />
                                <ErrorMessage
                                  name="lastName"
                                  className="text-danger"
                                  component="small"
                                />
                              </Col>
                              <Col md={6}>
                                <CustomIntlTelInput
                                  customValidation={isMobileNumberValid}
                                  containerClassName="intl-tel-input"
                                  style={{ width: '100%' }}
                                  inputClassName="form-control"
                                  onPhoneNumberChange={(
                                    valid,
                                    phone,
                                    selectedCountryData,
                                    fullNumber
                                  ) => {
                                    setFieldValue('mobile_number', {
                                      country_code:
                                        selectedCountryData.dialCode || '27',
                                      value: fullNumber,
                                      valid,
                                    });
                                  }}
                                />
                                <ErrorMessage
                                  name="mobile_number"
                                  className="text-danger"
                                  component="small"
                                />
                              </Col>
                              <Col md={6}>
                                <Field
                                  name="idNumber"
                                  className="form-control"
                                  placeholder="ID number"
                                />
                                <ErrorMessage
                                  name="idNumber"
                                  className="text-danger"
                                  component="small"
                                />
                              </Col>
                            </Row>
                            <Row className="pt-4">
                              <Col>
                                <h4>Employer</h4>
                              </Col>
                            </Row>
                            <Row>
                              <Col md={6}>
                                <Select
                                  placeholder="Select Employer"
                                  options={employers?.map((employer) => ({
                                    value: employer.id,
                                    label: employer.company_name,
                                  }))}
                                  onChange={(obj) => {
                                    this.setState({ employer: obj.value });
                                    setFieldValue('employer', obj.value);
                                  }}
                                />
                                <ErrorMessage
                                  name="employer"
                                  className="text-danger"
                                  component="small"
                                />
                              </Col>
                            </Row>
                            <Row className="pt-3">
                              <Col>
                                <button
                                  className="btn btn-primary float-right"
                                  type="submit"
                                  disabled={isSubmitting}>
                                  Create Temporary Employee
                                </button>
                              </Col>
                            </Row>
                          </form>
                        )}
                      </Formik>
                    </Col>
                  </Row>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </>
    );
  }
}

export default EmployeeAddTemporary;
